import React from 'react'
import styles from './FieldGroup.module.scss'

export default ({ className, children, collapse }) => (
  <div className={`${styles.group} ${className}`}>
    <div className={styles.inner} data-collapse={collapse} >
      { children }
    </div>
  </div>
)